import React from 'react';

export default function Hero({ eyebrow = 'COACHING COMMAND CENTER', title, subtitle, chips = [], stats = [], actions = [] }) {
  return (
    <section className="hero-panel">
      <div className="hero-orb hero-orb-one" />
      <div className="hero-orb hero-orb-two" />
      <div className="hero-main">
        <div className="hero-eyebrow">✦ {eyebrow}</div>
        <h1>{title}</h1>
        <p>{subtitle}</p>
        <div className="chip-row">
          {chips.map((chip, index) => <span className="hero-chip" key={`${String(chip)}-${index}`}>{chip}</span>)}
        </div>
        {!!actions.length && (
          <div className="hero-actions">
            {actions.map((action, index) => (
              <button key={`${action.label}-${index}`} className={action.primary ? 'button button-light' : 'button button-ghost-light'} onClick={action.onClick}>{action.icon} {action.label}</button>
            ))}
          </div>
        )}
      </div>
      {!!stats.length && (
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div className="hero-stat" key={`${stat.label}-${index}`}>
              <span className="stat-icon">{stat.icon}</span>
              <div><small>{stat.label}</small><strong>{stat.value}</strong></div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
